export {reducer as avMatrixReducer} from './av-matrix.reducer';
export {reducer as guiControlMatrixReducer} from './gui-control-matrix.reducer';
export {reducer as guiZonesReducer} from './gui-zones.reducer';
export {reducer as ioControlMatrixReducer} from './io-control-matrix.reducer';
export {reducer as projectReducer} from './project.reducer';
export {reducer as projectFeaturesReducer} from './project-features.reducer';
export {reducer as propertiesReducer} from './properties.reducer';
export {reducer as sbdReducer} from './sbd.reducer';
export {reducer as checklistReducer} from './checklist.reducer';
export {reducer as psfReducer} from './psf.reducer';
export {reducer as pmsReducer} from './pms.reducer';
export {reducer as uploadFilesReducer} from './upload-files.reducer';
export {reducer as testRackReducer} from './test-rack.reducer';
export {reducer as parametersReducer} from './parameters.reducer';
export {reducer as tokenReducer} from './tokens.reducer';
export {reducer as ggwReducer} from './ggw.reducer';
export {reducer as evidReducer} from './evid.reducer';
export {reducer as pnReducer} from './pn.reducer';
export {reducer as speakerSetupReducer} from './speaker-setup.reducer';
export {reducer as avodReducer} from './avod.reducer';
export {reducer as userdataGenerationReducer} from './userdata-generation.reducer';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/reducers/index.ts